import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { UserService } from 'shared/services/User/user.service';
import { PaymentService } from 'shared/services/Payment/payment.service';
import { Router } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { ConnectTeamModalComponent } from '../connect-team-modal/connect-team-modal.component';
import { MatDialog } from '@angular/material';
declare const stripe: any;

@Component({
  selector: 'app-leader-charge-card',
  templateUrl: './leader-charge-card.component.html',
  styleUrls: ['./leader-charge-card.component.css']
})
export class LeaderChargeCardComponent implements OnInit, AfterViewInit {
  cardRef: any;
  holdData: any;
  timerInt: any;
  loading: boolean;
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private us: UserService,
    private router: Router,
    private paymentService: PaymentService,
    private data: DataSharingService,
    private alertService: AlertPopupService,
    private dialog: MatDialog
  ) {
    /* this.holdData = JSON.parse(localStorage.getItem('holdSeatRes')); */
    this.data.currentHoldData.subscribe(response => {
      this.holdData = response;
      this.holdData.hold_data.max_pre_auth.new_deposit_due = Number(this.holdData.hold_data.max_pre_auth.new_deposit_due).toFixed(2);      
    });
    if (!this.holdData) {
      this.router.navigate(['/new-group']);
    }
    const elements = stripe.elements();
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };
    this.cardRef = elements.create('card', { style: style });
    this.cardRef.addEventListener('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  ngOnInit() {
    this.data.changeTitle('CHECKOUT');
    this.startTimer();
  }

  startTimer() {
    const timeVal = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const diff = this.holdData.hold_data.hold_tstamp_expire - now;
      this.timerInt = new Date(1000 * diff).toISOString().substr(14, 5);
      if (this.timerInt === '00:00') {
        clearInterval(this.timerInt);
        this.alertService.errorAlertWithResult('Your session has timed out.', 'Go Back', '/new-group');
      }
    }, 1000);
  }

  ngAfterViewInit(): void {
    this.cardRef.mount('#card-element');
  }

  submitPayment() {
    this.loading = true;
    stripe.createToken(this.cardRef).then((result) => {
      if (result.error) {
        // STRIPE RROR
        // Inform the user if there was an error.
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        this.loading = false;
      } else {
        // STRIPE SUCCESS, token generated, check if team auth exists
        const token = (result.token.id);

        // now check for team auth
        if (this.us.user.team_auths.filter(e => e.team_id_fk === this.holdData.team_id).length > 0) {
          // yes has auth
          this.chargeCard(token);
        } else {
          this.loading = false;
          const dialogRef = this.dialog.open(ConnectTeamModalComponent, {
            width: '600px',
            data: {
              teamId: this.holdData.team_id
            }
          });
        }
      }
    });
  }

  chargeCard(token) {
    this.loading = true;
    const amt = Number(this.holdData.hold_data.max_pre_auth.new_deposit_due);
    setTimeout(() => {
      this.paymentService.startGroupDeposit(amt, token, this.holdData.hold_data.order_num_out, this.holdData.team_id).subscribe(res => {
        this.loading = false;
        if (res.group_ob.group_id) {
          if (res.group_ob.group_status === 'PENDING_CONFIRM') {
            this.alertService.errorAlertWithResult('Thank you for using Season Share! Your season' +
              'ticket will be available within 24 hours. A confirmation message was sent to your email.', 'Go Back', '/groups');
          } else {
            clearInterval(this.timerInt);
            this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: res.group_ob.group_id } });
          }
        }
      }, err => {
        this.alertService.errorAlert('There was a problem reserving this seat. Please select another.');
        this.loading = false;
        this.router.navigate(['/new-group']);
      });
    }, 1500);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/leader-charge-card/leader-charge-card.component.ts